import { IMappedError } from './error.model';

export class BusinessRuleError {

  public mappedErrorList: IMappedError[];

  constructor(mappedErrorList: IMappedError[]) {
    this.mappedErrorList = mappedErrorList;
  }
}
